import React, { useState, useEffect } from 'react';
import { Container, ContainerInterno } from '../TaxasLote/styles';
import RModal from '../../../components/Rsuite/Modal';
import { useAuth } from '../../../hooks/auth';
import { CustomButton } from '../../../components/CustomButton';
import { CustomInput } from '../../../components/CustomInput';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';
import { CustomToggle } from '../../../components/CustomToggle';
import HelpOutlineIcon from '@rsuite/icons/HelpOutline';
import { toastWarning } from '../../../toasts';
import { NeighborhoodService } from '../../../services/neighborhood/neighborhoood.service';

const EditarCadastarBairro = ({
  modal,
  close,
  empresa,
  ObjBairro,
  setBairros,
}) => {
  const { id_empresa } = useAuth();
  const [idBairro, setIdBairro] = useState('');
  const [bairro, setBairro] = useState('');
  const [taxaEntrega, setTaxaEntrega] = useState('');
  const [cobraTaxa, setCobraTaxa] = useState('');
  const [ativo, setAtivo] = useState(false);
  const [prevaleciaTaxa, setPrevaleciaTaxa] = useState(false);
  const { theme } = useCustomTheme();

  const cadastrar = async () => {
    if (validarCampos()) {
      await NeighborhoodService.create({
        IdEmpresa: id_empresa,
        Bairro: bairro,
        TaxaEntrega: +taxaEntrega,
        Cidade: empresa.Cidade,
        Estado: empresa.Estado,
      }).then((data) => {
        setBairros((state) => [...state, data]);
        close();
      });
    } else {
      toastWarning('Preencha todos os campos');
    }
  };

  const editar = async () => {
    if (validarCampos()) {
      await NeighborhoodService.update(idBairro, {
        Bairro: bairro,
        TaxaEntrega: +taxaEntrega,
        CobraTaxa: cobraTaxa,
        PrevalenciaTaxaBairro: prevaleciaTaxa,
        Ativo: ativo,
      }).then((data) => {
        setBairros((state) => state.map((e) => (e.Id !== data.Id ? e : data)));
        close();
      });
    } else {
      if (taxaEntrega <= 0) {
        toastWarning('Taxa de entrega deve ser maior que zero');
      } else {
        toastWarning('Preencha todos os campos');
      }
    }
  };

  const validarCampos = () => {
    if (bairro !== '' && taxaEntrega !== '' && taxaEntrega > 0) {
      return true;
    }
    return false;
  };

  const dataTaxa = [
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
  ].map((item) => ({ label: item.label, value: item.value }));

  const abrirDados = (bairro) => {
    setIdBairro(bairro.Id);
    setBairro(bairro.Bairro);
    setTaxaEntrega(bairro.TaxaEntrega);
    setCobraTaxa(bairro.CobraTaxa);
    setAtivo(bairro.Ativo);
    setPrevaleciaTaxa(bairro.PrevalenciaTaxaBairro);
  };

  useEffect(() => {
    if (ObjBairro) {
      abrirDados(ObjBairro);
    }
  }, [ObjBairro]);

  return (
    <RModal
      open={modal}
      onClose={close}
      title={ObjBairro ? 'Editar Bairro' : 'Cadastrar Bairro'}
      footer={
        <>
          <CustomButton
            onClick={ObjBairro ? editar : cadastrar}
            appearance="primary"
          >
            Salvar
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <form>
        <Container>
          <ContainerInterno>
            <label
              htmlFor="bairro"
              style={{ color: theme.colors.textSecondary }}
            >
              Bairro
            </label>
            <CustomInput
              type="text"
              placeholder="Bairro"
              value={bairro}
              onChange={setBairro}
            />
          </ContainerInterno>
          <ContainerInterno>
            <label htmlFor="taxa">
              <b style={{ color: theme.colors.textSecondary }}>
                Taxa de Entrega
              </b>
            </label>
            <CustomInput
              type="number"
              placeholder="Taxa Entrega R$"
              value={taxaEntrega}
              onChange={setTaxaEntrega}
            />
          </ContainerInterno>
        </Container>
        {ObjBairro && (
          <Container>
            <ContainerInterno>
              <label htmlFor="cobrar">
                <b style={{ color: theme.colors.textSecondary }}>Cobrar Taxa</b>
              </label>
              <CustomSelectPicker
                data={dataTaxa}
                style={{ width: 100 }}
                onChange={setCobraTaxa}
                defaultValue={
                  ObjBairro !== null && ObjBairro.CobraTaxa === 'S'
                    ? dataTaxa[0].value
                    : dataTaxa[1].value
                }
                searchable={false}
              />
            </ContainerInterno>
            <ContainerInterno>
              <label htmlFor="cobrar">
                <b style={{ color: theme.colors.textSecondary }}>Status</b>
              </label>
              <CustomToggle
                id="ativo"
                checkedChildren="Ativo"
                unCheckedChildren="Inativo"
                checked={ativo}
                onChange={() => setAtivo(!ativo)}
              />
            </ContainerInterno>
            <ContainerInterno>
              <label
                htmlFor="prevaleciaTaxa"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: 170,
                }}
              >
                <b style={{ color: theme.colors.textSecondary }}>
                  Prevalência de Taxa{' '}
                  <HelpOutlineIcon
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      toastWarning(
                        'Se marcado, a taxa de entrega deste bairro prevalecerá sobre a taxa de entrega da empresa.',
                      )
                    }
                  />
                </b>
              </label>
              <CustomToggle
                checkedChildren="Ativo"
                unCheckedChildren="Inativo"
                checked={prevaleciaTaxa}
                onChange={() => setPrevaleciaTaxa(!prevaleciaTaxa)}
              />
            </ContainerInterno>
          </Container>
        )}
      </form>
    </RModal>
  );
};

export default EditarCadastarBairro;
